import { network } from 'services/network';

export const setCheckerConfigParams = (params) => {
    return network.post('api/bo/setCheckerConfigParams', params).then((response) => {
        return response.data;
    });
};
